import { AuthProvider } from './core/authentication/auth-provider';
import {
  RegisterCompanyConfirmRmParticipantModalComponent
} from './company/info/register-company-confirm-rm-participant-modal/register-company-confirm-rm-participant-modal.component';
import {
  RegisterCompanyAddEditParticipantModalComponent
} from './company/info/register-company-add-edit-participant-modal/register-company-add-edit-participant-modal.component';
import { environment } from './../environments/environment';
import { ApiModule, BASE_PATH, Configuration, ConfigurationParameters } from '@ent-regis/entregis-ts-angular';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { BodyComponent } from './layout/body/body.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { loaderConfig } from './config/loader-config';
import { CompanyComponent } from './company/company.component';
import { TimetableComponent } from './company/timetable/timetable.component';
import { InfoComponent } from './company/info/info.component';
import localeTh from '@angular/common/locales/th';
import { DatePipe, registerLocaleData } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { CdkTableModule } from '@angular/cdk/table';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppState } from './core/app-state';
import { AuthInterceptor } from './core/authentication/auth-interceptor';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { InvestorComponent } from './investor/investor.component';
import { MeetingRequestComponent } from './investor/meeting-request/meeting-request.component';
import { AvailableTimeComponent } from './investor/available-time/available-time.component';
import { HotelComponent } from './investor/hotel/hotel.component';
import { InvestorInfoComponent } from './investor/investor-info/investor-info.component';
import { ScheduleCompanyComponent } from './schedule-company/schedule-company.component';
import { ScheduleInvestorComponent } from './schedule-investor/schedule-investor.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ConsentModule } from './shared/modules/consent/consent.module';
import { PipesModule } from './shared/modules/pipes/pipes.module';
import { PresentationComponent } from './company/presentation/presentation.component';
import { MeetingTypePipe } from './shared/modules/pipes/meeting-type.pipe';
import { NotFoundModalComponent } from './check-in/not-found-modal/not-found-modal.component';
import { AlertCollectBadgeModalComponent } from './check-in/alert-collect-badge-modal/alert-collect-badge-modal.component';
import { CapsLockModalComponent } from './check-in/caps-lock-modal/caps-lock-modal.component';
import { LoginAdminComponent } from './login-admin/login-admin.component';
import { Adal8HTTPService, Adal8Service } from 'adal-angular8';
import { UnauthorizeComponent } from './unauthorize/unauthorize.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ReusedComponentModule } from './shared/modules/reused-component/reused-component.module';
import { LoginFooterComponent } from './layouts/login-layout/login-layout/login-footer/login-footer.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout/login-layout.component';
import { LoginHeaderComponent } from './layouts/login-layout/login-layout/login-header/login-header.component';
import { CompanyConsentComponent } from './company/pages/company-consent/company-consent.component';
import { CompanyParticipantSectionComponent } from './company/sections/company-participant-section/company-participant-section.component';
import { CompanyParticipantModalComponent } from './company/sections/company-participant-section/company-participant-modal/company-participant-modal.component';
import { CompanyTimeSectionComponent } from './company/sections/company-time-section/company-time-section.component';
import { CompanyPresentationSectionComponent } from './company/sections/company-presentation-section/company-presentation-section.component';
import { CompanyMeetingScheduleSectionComponent } from './company/sections/company-meeting-schedule-section/company-meeting-schedule-section.component';
import { InvestorConsentComponent } from './investor/pages/investor-consent/investor-consent.component';
import { InvestorProfileComponent } from './investor/pages/investor-profile/investor-profile.component';
import { InvestorPreferenceSectionComponent } from './investor/sections/investor-preference-section/investor-preference-section.component';
import { InvestorProfileSectionComponent } from './investor/sections/investor-profile-section/investor-profile-section.component';
import { InvestorAssistantSectionComponent } from './investor/sections/investor-assistant-section/investor-assistant-section.component';
import { DirectiveModule } from './shared/directives/directive.module';
import { InvestorCompanyComponent } from './investor/pages/investor-company/investor-company.component';
import { InvestorCompanySearchSectionComponent } from './investor/sections/investor-company-search-section/investor-company-search-section.component';
import { InvestorCompanySelectSectionComponent } from './investor/sections/investor-company-select-section/investor-company-select-section.component';
import { InvestorTimeComponent } from './investor/pages/investor-time/investor-time.component';
import { InvestorHotelComponent } from './investor/pages/investor-hotel/investor-hotel.component';
import { InvestorMeetingScheduleComponent } from './investor/pages/investor-meeting-schedule/investor-meeting-schedule.component';
let sharedApiModuleConfig: Configuration;

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
  };

  params.apiKeys = {
    Authorization: ''
  };

  if (sharedApiModuleConfig == null) {
    sharedApiModuleConfig = new Configuration(params);
  }
  return sharedApiModuleConfig;
}

export function init_app(authProvider: AuthProvider) {
  return () => authProvider.onAppLoaded();
}

registerLocaleData(localeTh);

@NgModule({
  entryComponents: [
    RegisterCompanyAddEditParticipantModalComponent,
    RegisterCompanyConfirmRmParticipantModalComponent,
    NotFoundModalComponent,
    AlertCollectBadgeModalComponent,
    CompanyParticipantModalComponent,
    CapsLockModalComponent
  ],
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    BodyComponent,
    CompanyComponent,
    TimetableComponent,
    InfoComponent,
    LoginComponent,
    RegisterCompanyAddEditParticipantModalComponent,
    RegisterCompanyConfirmRmParticipantModalComponent,
    InvestorComponent,
    MeetingRequestComponent,
    AvailableTimeComponent,
    InvestorInfoComponent,
    HotelComponent,
    ScheduleCompanyComponent,
    ScheduleInvestorComponent,
    PresentationComponent,
    NotFoundModalComponent,
    AlertCollectBadgeModalComponent,
    CapsLockModalComponent,
    LoginAdminComponent,
    UnauthorizeComponent,
    LoginFooterComponent,
    LoginLayoutComponent,
    LoginHeaderComponent,
    CompanyConsentComponent,
    CompanyParticipantSectionComponent,
    CompanyParticipantModalComponent,
    CompanyTimeSectionComponent,
    CompanyPresentationSectionComponent,
    CompanyMeetingScheduleSectionComponent,
    InvestorConsentComponent,
    InvestorProfileComponent,
    InvestorPreferenceSectionComponent,
    InvestorProfileSectionComponent,
    InvestorAssistantSectionComponent,
    InvestorCompanyComponent,
    InvestorCompanySearchSectionComponent,
    InvestorCompanySelectSectionComponent,
    InvestorTimeComponent,
    InvestorHotelComponent,
    InvestorMeetingScheduleComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgxUiLoaderModule.forRoot(loaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true, excludeRegexp: [
        'api/v1/public/register-investor\?',
        '/checkRegisterEmailDuplicate',
        '/exists-company/']
    }),
    ApiModule.forRoot(apiConfigFactory),
    CdkTableModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    TypeaheadModule.forRoot(),
    FontAwesomeModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    ConsentModule,
    PipesModule,
    DragDropModule,
    ReusedComponentModule,
    DirectiveModule,
  ],
  providers: [
    AppState,
    AuthProvider,
    {
      provide: BASE_PATH, useValue: environment.baseUrl
    },
    {
      provide: LOCALE_ID, useValue: 'en-US'
    },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      multi: true,
      deps: [AuthProvider]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,  // if error can be deleted
      multi: true,
    },
    DatePipe,
    MeetingTypePipe,
    Adal8Service,
    {
      provide: Adal8HTTPService, useFactory: Adal8HTTPService.factory, deps: [HttpClient, Adal8Service]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
